<template lang="pug">
  .page-account
    h1 Forgot
    form(@submit.prevent="submit" v-if="!success" v-disable-all="under18")
      .row(v-bind:class="v$.email.$error ? 'has_error' : ''")
        label(for="user_email") Email (Required)
        input(type="email" name="email" id="user_email" v-model="email" aria-describedby="user_email_error")
        span(aria-live="polite")
          p.error(v-for="error of v$.email.$errors" :key="error.$uid" v-html="error.$message" id="user_email_error")
      .row.two-cols
        div(v-bind:class="v$.birth_month.$error ? 'has_error' : ''")
          label(for="user_birth_month") Birth Month (MM) (Required)
          input(type="number" maxlength="2" name="birth_month" id="user_birth_month" v-model="birth_month" aria-describedby="user_birth_month_error")
          p.error(role="status" v-for="error of v$.birth_month.$errors" :key="error.$uid" v-html="error.$message" id="user_birth_month_error")
        div(v-bind:class="v$.birth_year.$error ? 'has_error' : ''")
          label(for="user_birth_year") Birth Year (YYYY) (Required)
          input(type="number" name="birth_year" id="user_birth_year" v-model="birth_year" aria-describedby="user_birth_year_error") 
          p.error(role="status" v-for="error of v$.birth_year.$errors" :key="error.$uid" v-html="error.$message" id="user_birth_year_error")
      div.btn(v-if="under18") Sorry, you are not eligible to register at this time.
      .row(v-if="!under18")
        input.btn--primary(type="submit" value="Reset")
      .row.link
        | Don't have an account? <a href="#" @click.prevent="$parent.setPage('signup')">Sign up here</a>
    div(v-if="success" aria-live="polite")
      | Email has been successfully sent!
</template>

<script>
  import { email, required, helpers, numeric, minValue, maxValue, sameAs } from '@vuelidate/validators';
  import { mandatory, minSize, maxSize } from '../../helpers/validators.js';
  import { useVuelidate } from '@vuelidate/core';

  export default {
    name: 'Forgot',

    components: {
    },

    props: {
    },

    setup() {
      return {
        v$: useVuelidate(null, null, {
          $lazy: true,
          $autoDirty: true
        })
      }
    },

    data() {
      return {
        email: '',
        birth_month: '',
        birth_year: '',
        under18: false,
        vuelidateExternalResults: {
          email: [],
          birth_month: [],
          birth_year: [],
        },
        success: false
      }
    },

    validations () {
      return {
        email: { required, email },
        birth_month: { required: mandatory('Birth month'), numeric, min: minValue(1), max: maxValue(12) },
        birth_year: { required: mandatory('Birth year'), numeric, min: minValue(1900), max: maxValue(2050) },
      }
    },

    methods: {
      async submit() {
        Object.assign(this.vuelidateExternalResults, {});
        const result = await this.v$.$validate();
        if (!result) {
          const firstErrorProperty = this.v$.$errors[0].$property;
          this.$el.querySelector(`[name=${firstErrorProperty}]`).focus();
          return;
        }

        const birth_date = `${this.birth_year}-${this.birth_month}-01`;

        // Age gate
        if (!this.v$.birth_year.$error && !this.v$.birth_month.$error) {
          const age = (new Date() - new Date(birth_date)) / (1000 * 60 * 60 * 24 * 365);
          if (age < 18) {
            localStorage.setItem('under18', 'yes');
            this.under18 = true;
            return;
          }
        }

        this.$parent.getRecaptchaToken((token) => {
          const data = {
            email: this.email,
            recaptcha_token: token
          };

          fetch(
            this.$parent.url + 'send-password-reset', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            }
          ).then(response => response.json()).then(data => {
            console.log(data)
            if (data.Result !== 'Success') {
              Object.assign(this.vuelidateExternalResults, { email: 'Not Found!' });
              return;
            }
            this.success = true;
          }).catch(() => {
          });
        });
      }
    },

    mounted() {
      this.$parent.createRecaptcha();
      this.$el.querySelector('#user_email').focus();
    }
  }
</script>

<style scoped lang="scss">
</style>
